import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { money } from "@/utils/numeral/money";

export const getMoneyTypographyCellRenderer =
  (
    key: keyof SavingsOpportunity,
    approximate: boolean = false,
  ): FC<CustomCellRendererProps<SavingsOpportunity>> =>
  (cell) => {
    const data = cell.data as SavingsOpportunity;
    const value = data?.[key];

    const cost = money(+(value ?? 0));

    return (
      <TypographyWithTooltip
        title={cost !== "N/A" && approximate ? `~${cost}` : cost}
        variant="body2"
      />
    );
  };
